module.exports = __webpack_public_path__ + "static/media/quadrupeds.e40aae9e.png";